import { Controller } from "@hotwired/stimulus"
import {
  trackUpgradePromptShown,
  trackUpgradePromptClicked,
} from "../modules/salary_lab/ga4_tracker"

export default class extends Controller {
  static values = { promptType: String, source: String }

  connect() {
    trackUpgradePromptShown(this.promptTypeValue, this.sourceValue)
  }

  clicked() {
    trackUpgradePromptClicked(this.promptTypeValue, this.sourceValue)
  }
}
